import { ChallengesActions, EChallengesActions } from "@edp-store/actions/challenges.actions";
import { IChallengesState, initialChallengesState } from "@edp-store/state/challenges.state";

export function challengesReducers(state = initialChallengesState, action: ChallengesActions): IChallengesState {
    switch (action.type) {
        case EChallengesActions.SaveChallengesLevels: {
            return {
                ...state,
                challengesLevels: action.payload,
            };
        }
        case EChallengesActions.SaveCollectiveChallenge: {
            return {
                ...state,
                collectiveChallenge: action.payload,
            };
        }
        case EChallengesActions.SaveExperiences: {
            return {
                ...state,
                experiences: action.payload,
            };
        }
        case EChallengesActions.SaveOtherEvents: {
            return {
                ...state,
                otherEvents: action.payload,
            };
        }
        case EChallengesActions.SaveChallengeAcceptance: {
            return {
                ...state,
                challengeAcceptance: action.payload,
            };
        }
        case EChallengesActions.SaveActiveChallenges: {
            return {
                ...state,
                activeChallenges: action.payload,
            };
        }
        case EChallengesActions.SaveInactiveChallenges: {
            return {
                ...state,
                inactiveChallenges: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
